// packages/frontend/src/services/firebaseUserMapping.ts

import type { User as FirebaseUser } from "firebase/auth";
import type { User } from "@msb/shared";

// Build a User from Firebase Auth data alone. Used as the session for accounts
// whose Firestore document cannot be read yet (unverified email, or the
// onUserCreate trigger has not run).
export const convertFirebaseUserToMSBUser = (firebaseUser: FirebaseUser): User => {
  // Try to extract name from displayName, or fall back to email username
  let firstName = "User";
  let lastName: string | undefined = undefined;

  if (firebaseUser.displayName) {
    const nameParts = firebaseUser.displayName.split(" ");
    firstName = nameParts[0] || "User";
    lastName = nameParts.slice(1).join(" ") || undefined;
  } else if (firebaseUser.email) {
    // Extract name from email (e.g., "aviv.laufer@gmail.com" -> "aviv")
    const emailParts = firebaseUser.email.split("@")[0].split(".");
    if (emailParts.length > 0) {
      firstName =
        emailParts[0].charAt(0).toUpperCase() + emailParts[0].slice(1);
      if (emailParts.length > 1) {
        lastName = emailParts
          .slice(1)
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(" ");
      }
    }
  }

  return {
    id: firebaseUser.uid,
    email: firebaseUser.email || undefined,
    prefix: undefined, // No prefix available from Firebase Auth alone
    firstName,
    lastName,
    userType: "therapist", // Default to therapist for now
    createdDate: new Date(firebaseUser.metadata.creationTime || Date.now()),
    lastLogin: new Date(firebaseUser.metadata.lastSignInTime || Date.now()),
    isActive: true,
  };
};
